export const VISIBLE_ORDER_IMAGES_COUNT = {
  TINY: 2,
  SMALL: 3
}

export const VISIBLE_ORDERS_COUNT = 5

// should always be multiple of VISIBLE_ORDERS_COUNT
export const PREFETCH_ORDERS_AMOUNT = 20
export const DOCUMENT_TYPES = {
  INVOICE: 'invoice',
  USAGE_NOTICE: 'custinformation',
  VOUCHER: 'creditnote'
}

export const ORDER_TYPES = {
  STANDARD: 'standard',
  SUBSCRIPTION: 'subscription'
}
